import { useCallback, useMemo, useState, type ReactNode } from "react";
import { ContextoDeCambios, type CambioPendiente, type Registro } from "@/hooks/useCambiosSinGuardar";

/** Registro de los formularios sucios del marco (Ajustes, Negocio, plantilla de Landing, pieza física, Equipo, Avanzado). */
export function CambiosSinGuardarProvider({ children }: { children: ReactNode }) {
  const [porId, setPorId] = useState<ReadonlyMap<string, CambioPendiente>>(new Map());
  // Identidad estable: los formularios la usan como dependencia de su efecto y un cambio la haría reentrar.
  const registrar = useCallback((id: string, cambio: CambioPendiente | null) => {
    setPorId((previo) => {
      const siguiente = new Map(previo);
      if (cambio) siguiente.set(id, cambio);
      else siguiente.delete(id);
      return siguiente;
    });
  }, []);
  const valor = useMemo<Registro>(() => ({ pendientes: [...porId.values()], registrar }), [porId, registrar]);
  return <ContextoDeCambios.Provider value={valor}>{children}</ContextoDeCambios.Provider>;
}

